import { createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "tp-error-area pt-120 pb-120" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row justify-content-center" }
const _hoisted_4 = { class: "col-xl-10" }
const _hoisted_5 = { class: "tp-error-wrapper text-center" }
const _hoisted_6 = { class: "tp-error-title" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "tp-error-thumb mb-50" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/assets/lms_website/website-assets/img/error/error.png",
    style: {"width":"50%"},
    alt: ""
  })
], -1 /* HOISTED */)
const _hoisted_8 = { class: "tp-error-content" }
const _hoisted_9 = { class: "tp-error-title-sm" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createElementBlock("main", null, [
    _createCommentVNode(" error area start "),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("h4", _hoisted_6, _toDisplayString($setup.lms_website.__('Oops!')), 1 /* TEXT */),
              _hoisted_7,
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("h4", _hoisted_9, _toDisplayString($setup.lms_website.__('Something went Wrong...')), 1 /* TEXT */),
                _createElementVNode("p", null, _toDisplayString($setup.lms_website.__("Sorry, we couldn't find your page.")), 1 /* TEXT */),
                _createVNode(_component_router_link, {
                  class: "tp-btn-inner",
                  to: {name:'home'}
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString($setup.lms_website.__('Back to Home')), 1 /* TEXT */)
                  ]),
                  _: 1 /* STABLE */
                })
              ])
            ])
          ])
        ])
      ])
    ]),
    _createCommentVNode(" error area end ")
  ]))
}